import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useSelector } from 'react-redux'

import plusIcon from 'images/todolist_plus_icon-16x16.png'
import particleAnimation from 'images/lottiefile/particle.json'
import firstCertificationImg from 'images/first_certification_img.png'
import middleCertificationImg from 'images/middle_certification_img.png'
import lastCertificationImg from 'images/last_certification_img.png'
import campaignEndModalImg from 'images/campaignEndModalImg.png'
import goForItImg from 'images/character/goForIt-199x130.png'
import uniThumbsUp from 'images/character/uni_thumbs_up-239x300.png'
import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json'
import goldCoin from 'images/character/gold_coin-338×266.png'
import uniFail from 'images/character/uni_fail.png'
import TodoListGroup from 'components/containers/task/TodoListGroup'

import TaskResultFormModal from 'components/containers/task/modal/TaskResultFormModal'
import ImageConfirmModal from 'components/presenters/modal/ImageConfirmModal'
import LottieLoader from 'components/containers/common/LottieLoader'
import ImageModal from 'components/presenters/modal/ImageModal'
import BottomModal from 'components/presenters/modal/BottomModal'
import CenterModal from 'components/presenters/modal/CenterModal'
import ReviewModal from 'components/containers/task/modal/ReviewModal'
import SocialShareModal from 'components/containers/share/SocialShareModal'
import LoadingAnimation from 'components/presenters/common/LoadingAnimation'

import server from 'server/serverController2'
import constants from 'utils/constants'
import { UserPermissionActions } from 'store/actionCreators'

import {
  compressImage,
  formatDate,
  removeItem,
  downloadFile,
  getBase64FromUrl,
  base64ToBlob,
} from 'utils/utils.js'
import {
  TodoListWrapper,
  HeaderWrapper,
  BodyWrapper,
  ImgFileInput,
  BodyInfoSection,
  InfoIconWrapper,
  InfoIcon,
  InfoTxt,
  FullScreen,
  EmptyContainer,
  EmptyImg,
  EmptyDesc,
  EmptyActionBtn,
  EmptyContent,
} from './style'
import _ from 'lodash'
import { useHistory } from 'react-router'
import { sendWebViewMsg } from 'utils/bridge'
import { useCallback } from 'react'

export default function TodoList({
  isLoading,
  isLoadingEnd,
  onEdit,
  onDeleteResult,
  currentDate,
  setCurrentDate,
  todoList,
  userRelation,
  setTodoList,
  emptyTxt,
  showAddBtn = true,
  disableCalendar = false,
  disableEditTask = false,
  style = {},
  updateTasks,
}) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })
  const userPermissionInfo = useSelector((state) => {
    return state.userPermission
  })
  const scrollRef = useRef(null)
  const currTaskVal = useRef(null)
  const currTaskNo = useRef(null)
  const history = useHistory()
  //ModalState
  const [modalVisible, setModalVisible] = useState(false)
  const [modalDataList, setModalDataList] = useState([])
  const [imageModalVisible, setImageModalVisible] = useState(false)
  const [imageModalDataList, setImageModalDataList] = useState(null)
  const [imageModalComplete, setImageModalComplete] = useState(null)
  const [initImageModalState, setInitImageModalState] = useState(false)

  //Upload
  const [currTask, setCurrTask] = useState(null)
  const [initUploadState, setInitUploadState] = useState(false)

  //Edit TaskResult
  const [initImgURL, setInitImgURL] = useState(null)

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  //ReviewModalState
  const [reviewModalVisible, setReviewModalVisible] = useState(false)

  const [relation, setRelation] = useState(null) // relation between current user and todolist owner
  // ex. guest, self, friend

  //CampaignEndModalState
  const [imageConfirmModalVisible, setImageConfirmModalVisible] = useState(false)
  const [imageConfirmModalDataList, setImageConfirmModalDataList] = useState(null)
  const [onImageConfirmModalCancel, setOnImageConfirmModalCancel] = useState(null)
  const [onImageConfirmModalComplete, setOnImageConfirmModalComplete] = useState(null)
  const [initImageConfirmModalState, setInitImageConfirmModalState] = useState(false)

  const [campaignSubmittion, setCampaignSubmittion] = useState(false)
  const [targetCampaign, setTargetCampaign] = useState(null)
  const [totalTaskNum, setTotalTaskNum] = useState(0)
  const [completeTaskNum, setCompleteTaskNum] = useState(0)
  //LottieState
  const [lottieOptions, setLottieOptions] = useState(null)

  //TaskResultFormModal
  const [showTaskResultForm, setShowTaskResultForm] = useState(false)
  const [targetTaskNo, setTargetTaskNo] = useState(null)

  const [resultModalFormId, setResultModalFormId] = useState(null)
  //SocialShareModal
  const [socialShareModalVisible, setSocialShareModalVisible] = useState(false)
  const [shareTaskNo, setShareTaskNo] = useState(null)
  const [shareImg, setShareImg] = useState(null)
  const [initSocialShareModal, setInitSocialShareModal] = useState(false)
  const [isCertProcessing, setIseCertProcessing] = useState(false)

  let isDeletingTaskResult = false

  //Initial Data Load
  useEffect(() => {
    setRelation(userRelation)
  }, [userRelation])

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  useEffect(() => {
    if (initImageModalState) {
      setImageModalVisible(false)
      setImageModalDataList(null)
      setLottieOptions(null)
      setInitImageModalState(false)
    }
  }, [initImageModalState])

  useEffect(() => {
    if (initImageConfirmModalState) {
      setImageConfirmModalVisible(false)
      setImageConfirmModalDataList(null)
      setOnImageConfirmModalCancel(null)
      setOnImageConfirmModalComplete(null)
      setInitImageConfirmModalState(false)
    }
  }, [initImageConfirmModalState])

  //Upload Result Flow
  useEffect(() => {
    if (initUploadState === true) {
      setInitImgURL(null)
      setCurrTask(null)
      setShowTaskResultForm(false)
      setModalVisible(false)
      setModalDataList([])
      setInitUploadState(false)
    }
  }, [initUploadState])

  useEffect(() => {
    if (initSocialShareModal) {
      setSocialShareModalVisible(false)
      setShareTaskNo(null)
      setShareImg(null)
      setInitSocialShareModal(false)
    }
  }, [initSocialShareModal])

  useEffect(() => {
    if (todoList.length) {
      const tasks = getTotalTasks(todoList)
      let count = 0
      for (let i = 0; i < tasks.length; ++i) {
        if (tasks[i] && tasks[i]['proof']) {
          count++
        }
      }
      setCompleteTaskNum(count)
      setTotalTaskNum(tasks.length)
    }
  }, [todoList])

  const checkUserConfirmResult = useCallback(async () => {
    const achievementRes = await server.getRequestData(
      `campaigns/${currTaskVal.current.no}/members/${userInfo['id']}/achievement`,
    )
    if (achievementRes.success !== 1) {
      return
    }
    const achievementData = achievementRes.data
    const resultCount = parseInt(achievementData.result_count)
    const taskCount = parseInt(achievementData.task_count)
    const achievementRate = Math.floor((resultCount / taskCount) * 100)

    const confirmResultRes = await server.getRequestData('users/confirm')

    if (confirmResultRes.success !== 1) {
      return
    }
    const confirmResultData = confirmResultRes.data.confirm_data
    const isReviewModal = confirmResultData.review_modal

    if (isReviewModal === true) {
      return false
    } else if (achievementRate >= 50 && isReviewModal === false) {
      return true
    }
  }, [userInfo])

  const handleOpenCompleteModal = useCallback(
    async (point, productChallengeAttendee) => {
      const completeCurrentTaskNum = completeTaskNum + 1
      // if (
      //   !permissions &&
      //   currTask['type'] === 'campaign' &&
      //   userPermissionInfo['matching'] === false
      // ) {
      //   const campaignTodoList = getCampaignTodoList(currTask['campaign_no'])
      //   setTargetCampaign(campaignTodoList)
      //   if (campaignTodoList['end_date'] === formatDate()) {
      //     let count = 0
      //     for (let i = 0; i < campaignTodoList['tasks'].length; ++i) {
      //       if ([null, undefined].includes(campaignTodoList['tasks'][i]['proof'])) {
      //         count++
      //       }
      //     }
      //     if (count === 1) {
      //       setImageModalDataList({
      //         title: '다음엔 끝까지 완주해 봐요!',
      //         description: `분명히 할 수 있어요 \n 응원할게요🔥`,
      //         modalImg: goForItImg,
      //         buttonText: 'OK! 할 수 있어!',
      //       })
      //       setImageModalComplete(() => () => setInitImageModalState(true))
      //       setCompleteTaskNum(completeCurrentTaskNum)
      //       setImageModalVisible(true)
      //       return
      //     }
      //   }
      // }
      if (
        currTaskVal.current.type === 'product_challenge' &&
        productChallengeAttendee.auths[0].min_auth ===
          productChallengeAttendee.auths[0].curr_auth &&
        productChallengeAttendee?.is_success
      ) {
        setImageModalDataList({
          title: '환급조건 달성!',
          description: `축하해요!!🎉\n환급은 영업일 기준 2~5일 이내로\n처리될 예정이에요!`,
          modalImg: goldCoin,
          buttonText: '확인',
        })
      } else if (completeCurrentTaskNum === 1 && todoList.length !== 1) {
        setImageModalDataList({
          title: '오늘의 첫 미션 Clear!',
          description: '다른 모티너들이 자극받고 있어요!',
          point: point,
          modalImg: firstCertificationImg,
          buttonText: 'OK! 할 수 있어!🔥',
        })
      } else if (completeCurrentTaskNum === totalTaskNum) {
        setImageModalDataList({
          title: '대단해요!',
          description: '오늘 할 일을 모두 끝냈어요!',
          point: point,
          modalImg: lastCertificationImg,
          buttonText: '나 너무 칭찬해😊',
        })
      } else {
        setImageModalDataList({
          title: '한발짝 한발짝',
          description: '목표에 가까워지고 있어요!',
          point: point,
          modalImg: middleCertificationImg,
          buttonText: '짝짝짝짝👏',
        })
      }
      if (currTaskVal.current['type'] === 'campaign') {
        //여기서 모달 띄어주면됨
        const isReviewModal = await checkUserConfirmResult()

        if (isReviewModal) {
          setImageModalComplete(() => () => {
            setInitImageModalState(true)
            setReviewModalVisible(true)
          })
        } else {
          setImageModalComplete(() => () => setInitImageModalState(true))
        }
      } else if (currTaskVal.current.type === 'product_challenge') {
        const productNo = currTaskVal.current['product_no']
        setImageModalComplete(
          () => () => history.push(`/motishop/product/${productNo}/achievement`),
        )
      } else {
        setImageModalComplete(() => () => setInitImageModalState(true))
      }
      setCompleteTaskNum(completeCurrentTaskNum)
      setImageModalVisible(true)
      setLottieOptions({
        loop: false,
        autoplay: true,
        renderer: 'svg',
        animationData: particleAnimation,
      })
    },
    [checkUserConfirmResult, completeTaskNum, history, todoList.length, totalTaskNum],
  )

  //Upload Flow End

  const getTotalTasks = (newTodoList) => {
    if (newTodoList.length) {
      let tasks = []
      const typeFields = ['campaign', 'group', 'normal', 'routine', 'onboarding']
      for (let values of newTodoList) {
        if (typeFields.includes(values['type'])) {
          if (values['type'] === 'campaign') {
            if (values?.tasks) {
              tasks = [...tasks, ...values['tasks']]
            }
          } else if (values['type'] === 'group') {
            if (values?.tasks) {
              tasks = [...tasks, ...values['tasks']]
            }
          } else if (values['type'] === 'routine') {
            if (values?.task) {
              tasks = [...tasks, values['task']]
            }
          } else {
            if (values) {
              tasks = [...tasks, values]
            }
          }
        }
      }

      return tasks
    }
  }

  //Delete Task Flow
  const handleDeleteTask = (params) => {
    server.deleteRequestData(`tasks/${params['task_no']}`, {}, (res) => {
      if (res.success !== 1) {
        return
      }
      let jsonData = res.data
      let targetTaskNo = jsonData['deleted_item'][0]['no']
      setTodoList([...getDeletedTodoList(targetTaskNo)])
      getTotalTasks([...getDeletedTodoList(targetTaskNo)])
      setModalVisible(false)
      onEdit()
    })
  }

  const getDeletedTodoList = (targetNo) => {
    let targetIndex = null
    for (let i = 0; i < todoList.length; ++i) {
      if (todoList[i]['no'] === targetNo) {
        targetIndex = i
        break
      }
    }
    return removeItem(todoList, targetIndex)
  }

  //Delete Routine Flow
  const handleDeleteRoutine = (params) => {
    server.deleteRequestData(`tasks/routines/${params['routine_no']}`, {}, (res) => {
      if (res.success !== 1) {
        return
      }
      let jsonData = res.data
      let targetRoutineNo = jsonData['deleted_item'][0]['no']
      setTodoList([...getDeletedTodoList(targetRoutineNo)])
      setModalVisible(false)
      onEdit()
    })
  }

  //handle Delete Task Result
  const handleDeleteTaskResult = (params) => {
    if (isDeletingTaskResult === false) {
      isDeletingTaskResult = true
      server.deleteRequestData(`tasks/${params['task_no']}/result`, {}, (res) => {
        isDeletingTaskResult = false
        try {
          if (res.success === 0) {
            // setModalVisible(false)
            // setCenterModalVisible(true)
            const errData = res?.error?.res_data
            if (errData?.detail_code === 'PAYBACK_ALREADY_PROCESSED') {
              setCenterModalDataList({
                description: `환급챌린지 인증사진은\n 삭제가 불가능합니다.\n 관리자에게 문의해주세요.`,
              })
            } else {
              setCenterModalDataList({
                description: `투두리스트 삭제에 실패했어요.\n 나중에 다시 시도해주세요.`,
              })
            }
            setOnModalComplete(() => () => setInitCenterModal(true))
            return
          }
          let jsonData = res['data']
          let targetNo = jsonData['deleted_item'][0]['task_no']
          deleteTodoListProof(targetNo)
          // setModalVisible(false)
          setInitCenterModal(true)
          onEdit()
          if (onDeleteResult) {
            onDeleteResult({
              task: getTaskInfo(params['task_no']),
              result: jsonData['deleted_item'][0],
            })
          }
        } catch (err) {}
      })
    }
  }

  const handleTaskDeleteCenterModal = (currTask) => {
    setCenterModalDataList({
      type: 'callback',
      title: '게시물 삭제',
      description: '게시물을 삭제하시겠어요?\n적립된 포인트와\n스티커도 함께 사라져요.',
    })

    setOnModalComplete(() => () => {
      handleDeleteTaskResult(currTask)
    })
    setOnModalCancel(() => () => setCenterModalVisible(false))
    setCenterModalVisible(true)
    setModalVisible(false)
  }

  // Iterate Function
  const getCampaignTodoList = (campaignNo) => {
    for (let i = 0; i < todoList.length; ++i) {
      if (
        todoList[i]['type'] === 'campaign' &&
        parseInt(todoList[i]['no']) === parseInt(campaignNo)
      ) {
        return todoList[i]
      }
    }
  }
  const getTaskInfo = (targetNo) => {
    for (let i = 0; i < todoList.length; ++i) {
      if (todoList[i]['type'] === 'campaign') {
        let taskList = todoList[i]['tasks']
        if (![null, undefined].includes(taskList)) {
          for (let j = 0; j < taskList.length; ++j) {
            if (taskList[j]['no'] === targetNo) {
              return {
                ...taskList[j],
                campaign_no: todoList[i]['no'],
              }
            }
          }
        }
      } else if (todoList[i]['type'] === 'group') {
        let projectLists = todoList[i]['projects']

        for (let j = 0; j < projectLists.length; ++j) {
          let taskList = projectLists[j]['tasks']
          if (![null, undefined].includes(taskList)) {
            for (let k = 0; k < taskList.length; ++k) {
              if (taskList[k]['no'] === targetNo) {
                return {
                  ...taskList[k],
                  group_no: todoList[i]['no'],
                  project_no: projectLists[j]['no'],
                }
              }
            }
          }
        }
      } else if (todoList[i]['type'] === 'routine') {
        if (todoList[i]['task'] && todoList[i]['task']['no'] === targetNo) {
          return {
            ...todoList[i]['task'],
            routine_no: todoList[i]['no'],
          }
        }
      } else if (todoList[i]['type'] === 'onboarding') {
        if (todoList[i]['no'] === targetNo) {
          return {
            ...todoList[i],
            onboarding_no: todoList[i]['no'],
          }
        }
      } else if (todoList[i]['type'] === 'normal') {
        if (todoList[i]['no'] === targetNo) {
          return { ...todoList[i] }
        }
      } else if (todoList[i]['type'] === 'product_challenge') {
        const taskList = todoList[i]['tasks']
        if (![null, undefined].includes(taskList)) {
          for (let j = 0; j < taskList.length; ++j) {
            if (taskList[j]['no'] === targetNo) {
              return {
                ...taskList[j],
                product_challenge_no: todoList[i]['no'],
              }
            }
          }
        }
      }
    }
  }

  const getReplacedTodoList = (targetNo, newTask) => {
    for (let i = 0; i < todoList.length; ++i) {
      if (todoList[i]['type'] === 'campaign') {
        let taskList = todoList[i]['tasks']
        if (![null, undefined].includes(taskList)) {
          for (let j = 0; j < taskList.length; ++j) {
            if (taskList[j]['no'] === targetNo) {
              taskList[j] = newTask
            }
          }
        }
      } else if (todoList[i]['type'] === 'group') {
        let projectLists = todoList[i]['projects']
        if (![null, undefined].includes(projectLists)) {
          for (let j = 0; j < projectLists.length; ++j) {
            let taskList = projectLists[j]['tasks']
            if (![null, undefined].includes(taskList)) {
              for (let k = 0; k < taskList.length; ++k) {
                if (taskList[k]['no'] === targetNo) {
                  taskList[k] = newTask
                }
              }
            }
          }
        }
      } else if (todoList[i]['type'] === 'routine') {
        if (todoList[i]['task'] && todoList[i]['task']['no'] === targetNo) {
          todoList[i]['task'] = newTask
        }
      } else if (todoList[i]['type'] === 'normal') {
        if (todoList[i]['no'] === targetNo) {
          todoList[i] = newTask
        }
      }
      // TODO: onboarding type
    }
    return [...todoList]
  }

  const addTodoListProof = useCallback(
    (targetNo, proof) => {
      let newTodoList = todoList
      for (let i = 0; i < newTodoList.length; ++i) {
        if (newTodoList[i]['type'] === 'campaign') {
          let taskList = newTodoList[i]['tasks']
          if (![null, undefined].includes(taskList)) {
            for (let j = 0; j < taskList.length; ++j) {
              if (taskList[j]['no'] === targetNo) {
                taskList[j]['proof'] = proof
              }
            }
          }
        } else if (newTodoList[i]['type'] === 'group') {
          let projectLists = newTodoList[i]['projects']
          if (![null, undefined].includes(projectLists)) {
            for (let j = 0; j < projectLists.length; ++j) {
              let taskList = projectLists[j]['tasks']
              if (![null, undefined].includes(taskList)) {
                for (let k = 0; k < taskList.length; ++k) {
                  if (taskList[k]['no'] === targetNo) {
                    taskList[k]['proof'] = proof
                  }
                }
              }
            }
          }
        } else if (newTodoList[i]['type'] === 'routine') {
          if (newTodoList[i]['task'] && newTodoList[i]['task']['no'] === targetNo) {
            newTodoList[i]['task']['proof'] = proof
          }
        } else if (newTodoList[i]['type'] === 'normal') {
          if (newTodoList[i]['no'] === targetNo) {
            newTodoList[i]['proof'] = proof
          }
        } else if (newTodoList[i]['type'] === 'onboarding') {
          if (newTodoList[i]['no'] === targetNo) {
            newTodoList[i]['proof'] = proof
          }
        }
      }
      getTotalTasks(newTodoList)
      setTotalTaskNum()
      setTodoList([...newTodoList])
    },
    [setTodoList, todoList],
  )

  const deleteTodoListProof = (targetNo) => {
    let newTodoList = todoList
    for (let i = 0; i < newTodoList.length; ++i) {
      if (newTodoList[i]['type'] === 'campaign') {
        let taskList = newTodoList[i]['tasks']
        if (![null, undefined].includes(taskList)) {
          for (let j = 0; j < taskList.length; ++j) {
            if (taskList[j]['no'] === targetNo) {
              delete taskList[j]['proof']
            }
          }
        }
      } else if (newTodoList[i]['type'] === 'group') {
        let projectLists = newTodoList[i]['projects']

        if (![null, undefined].includes(projectLists)) {
          for (let j = 0; j < projectLists.length; ++j) {
            let taskList = projectLists[j]['tasks']
            if (![null, undefined].includes(taskList)) {
              for (let k = 0; k < taskList.length; ++k) {
                if (taskList[k]['no'] === targetNo) {
                  delete taskList[k]['proof']
                }
              }
            }
          }
        }
      } else if (newTodoList[i]['type'] === 'routine') {
        if (newTodoList[i]['task'] && newTodoList[i]['task']['no'] === targetNo) {
          delete newTodoList[i]['task']['proof']
        }
      } else if (newTodoList[i]['type'] === 'normal') {
        if (newTodoList[i]['no'] === targetNo) {
          delete newTodoList[i]['proof']
        }
      } else if (newTodoList[i]['type'] === 'onboarding') {
        if (newTodoList[i]['no'] === targetNo) {
          delete newTodoList[i]['proof']
        }
      }
    }
    getTotalTasks(newTodoList)
    setTodoList([...newTodoList])
  }

  const handleShareTaskResult = async (currTask) => {
    try {
      const taskImages = currTask.proof.map((img) => {
        return `${constants.imagePath}/task_img/${img}`
      })

      const dataUrl = await getBase64FromUrl(taskImages[0])

      if (currTask['share_req']) {
        setSocialShareModalVisible(true)
        setShareTaskNo(currTask['no'])
        setShareImg(dataUrl)
        setModalVisible(false)
        return
      }

      const res = await sendWebViewMsg({
        action: 'REQ_INSTAGRAM_SHARE',
        data: {
          share_options: {
            url: dataUrl,
            type: 'image/*',
          },
        },
      }).catch((err) => {
        console.log('err from msg')
        console.log(err)
      })
    } catch (err) {
      console.log('error')
      console.log(err)
    }
  }
  //모티샵 logic
  const handleChallengeStartClick = (relation, attendee) => {
    if (relation !== 'self') {
      return
    }
    setCenterModalVisible(true)
    setCenterModalDataList({
      title: '인증 시작하기',
      description: `제품을 받으셨나요?\n확인버튼 클릭 시, 오늘부터\n${attendee.period}일간 환급 챌린지가 시작돼요!`,
    })
    setOnModalCancel(() => () => setInitCenterModal(true))
    setOnModalComplete(() => () => requestStartChallenge(attendee.no))
  }

  const requestStartChallenge = async (attendeeNo) => {
    try {
      const response = await server.postRequestData(
        `commerce/challenges/attendees/${attendeeNo}/start`,
      )
      if (response.success !== 1) {
        const errData = response.error.res_data
        throw errData
      }

      updateTasks()
      setInitCenterModal(true)
    } catch (error) {
      console.log(error)
    }
  }

  const handleError = (error) => {
    if (error['error_detail'] === 'FRIEND_STATUS_REQUIRED') {
      setCenterModalVisible(true)
      setCenterModalDataList({
        description: '친구가 되면 게시물을 볼 수 있어요!',
      })
      setOnModalComplete(() => () => {
        setInitCenterModal(true)
      })
    } else if (error['error_detail'] === 'SUBMITION_TIME_NOT_STARTED') {
      setCenterModalVisible(true)
      setCenterModalDataList({
        description: '아직 인증시간이 시작되지 않았습니다.',
      })
      setOnModalComplete(() => () => {
        setInitCenterModal(true)
      })
    }
  }

  // new 인증 logic

  const getTemplateImageURI = useCallback(async (taskNo) => {
    try {
      const response = await server.getRequestData(`tasks/${taskNo}/templates`)

      if (response.success !== 1) {
        const errData = response
        throw errData
      }

      const { templates } = response.data
      return templates.length > 0 ? templates[0].file_name : null
    } catch (err) {
      console.log(err)
    }
  }, [])

  const submitResult = useCallback(
    async ({ taskNo, proof, originalProof, description }) => {
      const startTime = new Date().getTime()
      let currDateTime
      let diffDateTime
      try {
        let proofBlob
        let originalProofBlob

        if (proof && originalProof) {
          ;[proofBlob, originalProofBlob] = await Promise.all([
            base64ToBlob(proof),
            base64ToBlob(originalProof),
          ])
        }
        // 첫번째 로그
        currDateTime = new Date().getTime()
        diffDateTime = Math.floor((currDateTime - startTime) / 1000)
        if (diffDateTime > 2) {
          console.log(`proof dataUrl to blob : ${diffDateTime}s`)
        }
        //

        const proofMimeTypeFound = proof.match(/^data:([^\\/]+\/[^\\/]+?);/)
        const originalProofMimeTypeFound = originalProof.match(/^data:([^\\/]+\/[^\\/]+?);/)

        const proofMimeType = Array.isArray(proofMimeTypeFound)
          ? proofMimeTypeFound[1]
          : 'image/png'
        const originalProofMimeType = Array.isArray(originalProofMimeTypeFound)
          ? originalProofMimeTypeFound[1]
          : 'image/png'

        const formData = new FormData()
        formData.append('file', new Blob([proofBlob], { type: proofBlob.type || proofMimeType }))
        formData.append(
          'original_file',
          new Blob([originalProofBlob], { type: originalProofBlob.type || originalProofMimeType }),
        )
        formData.append('description', description ?? '')

        const response = await server.postRequestFormData(`tasks/${taskNo}/result`, formData)

        //두번째 로그
        currDateTime = new Date().getTime()
        diffDateTime = Math.floor((currDateTime - startTime) / 1000)
        if (diffDateTime > 3) {
          console.log(`task result submit : ${diffDateTime}s`)
        }
        //

        if (response.success !== 1) {
          const errData = response.error.res_data

          throw errData
        }

        const result = response.data?.updated_item
          ? response.data?.updated_item[0]
          : response.data?.inserted_item

        const targetTaskNo = result.no
        const targetProof = result.proof[0]
        const point = result.point
        const productChallengeAttendee = result.product_challenge?.attendee
        addTodoListProof(targetTaskNo, targetProof)

        if (point) {
          handleOpenCompleteModal(point, productChallengeAttendee)
        }

        onEdit()
        setIseCertProcessing(false)
      } catch (error) {
        const { detail_code: detailCode } = error
        setCenterModalVisible(true)

        let centerModalDesc
        let onCenterModalComplete
        if (detailCode === 'TASK_DATE_NOT_ALLOWED') {
          centerModalDesc = '인증 가능한 시간이 아니에요.'
          onCenterModalComplete = () => {
            setInitCenterModal(true)
          }
        } else if (detailCode === 'SUBMITION_TIME_NOT_STARTED') {
          centerModalDesc = '아직 인증시간이 시작되지 않았어요.'
          onCenterModalComplete = () => {
            setInitCenterModal(true)
          }
        } else if (detailCode === 'SUBMITION_TIME_ENDED') {
          centerModalDesc = '이미 인증시간이 지났어요.'
          onCenterModalComplete = () => {
            setInitCenterModal(true)
          }
        } else {
          centerModalDesc = '예기치못한 에러가 발생했어요. 다시 시도해주세요.'
          onCenterModalComplete = () => {
            setInitCenterModal(true)
          }
        }

        setCenterModalDataList({ description: centerModalDesc })
        setOnModalComplete(() => onCenterModalComplete)
      } finally {
        currTaskVal.current = null
      }
    },
    [addTodoListProof, handleOpenCompleteModal, onEdit],
  )

  const handleOpenCertificationScreen = useCallback(
    async (taskNo, templateImgFileName) => {
      try {
        const templateImgURL = templateImgFileName
          ? `${constants.imagePath}/task_template_img/${templateImgFileName}`
          : templateImgFileName
        const response = await sendWebViewMsg({
          action: 'REQ_OPEN_CERTIFICATION',
          data: {
            templateImgURL,
          },
        })

        if (response.success !== 1) {
        }
        const startTime = new Date().getTime()
        let currDateTime
        let diffDateTime
        setIseCertProcessing(true)

        const { proof, original_proof, description } = response.data
        await submitResult({
          taskNo,
          proof,
          originalProof: original_proof,
          description,
        })
        // 마지막 로그
        currDateTime = new Date().getTime()
        diffDateTime = Math.floor((currDateTime - startTime) / 1000)
        if (diffDateTime > 2) {
          console.log(`certification flow end : ${diffDateTime}s`)
        }
        //
      } catch (err) {
        if (
          err.detail_error === 'APP_NOT_DETECTED' ||
          err.error.res_data.err_code === 'ACTION_NOT_EXISTS'
        ) {
          document.getElementById(`taskResultImg${resultModalFormId}`).click()
        }
        console.log('error:', err)
      }
    },
    [resultModalFormId, submitResult],
  )

  const handleCertBtnClick = useCallback(
    async (value) => {
      try {
        if (!currTaskVal.current) return
        const currTask = currTaskNo.current

        const { no: currTaskId } = currTask
        const templateImageURI = await getTemplateImageURI(currTaskId)
        await handleOpenCertificationScreen(currTaskId, templateImageURI)
      } catch (err) {
        console.log(err)
      }
    },
    [getTemplateImageURI, handleOpenCertificationScreen],
  )

  const handleOpenCertificationModificationScreen = useCallback(
    async (taskNo, templateImgFileName, originalCertificatedImageUrl, originalDescription) => {
      try {
        const templateImgURL = templateImgFileName
          ? `${constants.imagePath}/task_template_img/${templateImgFileName}`
          : templateImgFileName
        const response = await sendWebViewMsg({
          action: 'REQ_OPEN_CERTIFICATION_MODIFICATION',
          data: {
            templateImgURL,
            originalCertificatedImageUrl: `${constants.imagePath}/task_img/${originalCertificatedImageUrl}`,
            originalDescription,
          },
        })

        if (response.success !== 1) {
        }

        setIseCertProcessing(true)

        // proof와 original_proof는 undefined
        const { proof, original_proof, description } = response.data
        await submitResult({
          taskNo,
          proof,
          originalProof: original_proof,
          description,
        })
      } catch (err) {
        if (
          err.detail_error === 'APP_NOT_DETECTED' ||
          err.error.res_data.err_code === 'ACTION_NOT_EXISTS'
        ) {
          setShowTaskResultForm(true)
        }
        console.log(err)
      }
    },
    [submitResult],
  )

  const handleCertModiClick = useCallback(
    async (value) => {
      try {
        if (!currTaskVal.current) return

        const currTask = Array.isArray(value.tasks)
          ? value.tasks
            ? value.tasks[0]
            : value.task
          : value

        const {
          no: currTaskNo,
          proof: [taskProof],
          description,
        } = currTask

        const templateImageURI = await getTemplateImageURI(currTaskNo)
        await handleOpenCertificationModificationScreen(
          currTaskNo,
          templateImageURI,
          taskProof,
          description,
        )
      } catch (err) {
        console.log(err)
      }
    },
    [getTemplateImageURI, handleOpenCertificationModificationScreen],
  )

  // useEffect(() => {
  //   if (!currTask) return
  //   handleCertBtnClick(currTask)
  // }, [currTask, handleCertBtnClick])

  //Iterate Function End
  return (
    <TodoListWrapper style={style}>
      <HeaderWrapper></HeaderWrapper>
      <BodyWrapper ref={scrollRef}>
        {!userInfo.isLogin ? (
          <BodyInfoSection>
            <InfoIconWrapper>
              <InfoIcon src={uniThumbsUp} />
            </InfoIconWrapper>
            <InfoTxt>
              로그인하고 챌린지에
              <br />
              도전해 봐요!
            </InfoTxt>
          </BodyInfoSection>
        ) : isLoading ? (
          <LottieLoader
            lottieFile={loadingAnimation}
            lottieOptions={{
              loop: true,
              autoplay: true,
              renderer: 'svg',
              animationData: loadingAnimation,
            }}
            style={{
              position: 'absolute',
              top: '0',
              bottom: '0',
              left: '0',
              right: '0',
              margin: 'auto',
              width: 'calc(100vw * (45 / 375))',
              height: 'calc(100vw * (45 / 375))',
            }}
          />
        ) : isLoadingEnd && todoList.length <= 0 ? (
          <EmptyContainer>
            <EmptyContent>
              <EmptyImg src={uniFail} />
              <EmptyDesc>참여 챌린지가 없어요.</EmptyDesc>
              <EmptyActionBtn onClick={() => history.push('/')}>챌린지 둘러보기</EmptyActionBtn>
            </EmptyContent>
          </EmptyContainer>
        ) : (
          <>
            {todoList.map((value) => {
              return (
                <TodoListGroup
                  key={`todolist-${value['type']}-no-${value['no']}`}
                  listInfo={value}
                  setModalVisible={setModalVisible}
                  setModalDataList={setModalDataList}
                  setCurrTask={setCurrTask}
                  currTaskNo={currTaskNo}
                  onTriggerSelectImg={() => {
                    currTaskVal.current = value
                    handleCertBtnClick(value)
                  }}
                  onEditTaskResult={(params) => {
                    setModalVisible(false)
                    const targetTask = getTaskInfo(params['task_no'])
                    setCurrTask(targetTask)
                    // setShowTaskResultForm(true)                currTaskVal.current = value
                    currTaskVal.current = value
                    handleCertModiClick(value)
                  }}
                  onDeleteTask={handleDeleteTask}
                  onDeleteRoutine={handleDeleteRoutine}
                  onDeleteTaskResult={handleTaskDeleteCenterModal}
                  disableEditTask={disableEditTask}
                  relation={relation}
                  onError={(error) => handleError(error)}
                  onShareTaskResult={handleShareTaskResult}
                  onChallengeStartClick={handleChallengeStartClick}
                />
              )
            })}
          </>
        )}
        {/* {userInfo['isLogin'] === true ? (
          <>
            {isLoading === true && isLoadingEnd === false && (
              <LottieLoader
                lottieFile={loadingAnimation}
                lottieOptions={{
                  loop: true,
                  autoplay: true,
                  renderer: 'svg',
                  animationData: loadingAnimation,
                }}
                style={{
                  position: 'absolute',
                  top: '0',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  margin: 'auto',
                  width: 'calc(100vw * (45 / 375))',
                  height: 'calc(100vw * (45 / 375))',
                }}
              />
            )}
            {isLoading === false && isLoadingEnd === true && todoList?.length === 0 && (
              <BodyInfoSection>
                <InfoIconWrapper>
                  <InfoIcon src={uniThumbsUp} />
                </InfoIconWrapper>
                <InfoTxt>
                  {emptyTxt ? (
                    emptyTxt
                  ) : formatDate(currentDate) === formatDate() ? (
                    <>
                      오늘은 인증이 없어요.
                      <br />
                      챌린지에 도전
                    </>
                  ) : (
                    <>인증기록이 없어요.</>
                  )}
                </InfoTxt>
              </BodyInfoSection>
            )}
          </>
        ) : (
          <BodyInfoSection>
            <InfoIconWrapper>
              <InfoIcon src={uniThumbsUp} />
            </InfoIconWrapper>
            <InfoTxt>
              로그인하고 챌린지에
              <br />
              도전해 봐요!
            </InfoTxt>
          </BodyInfoSection>
        )}
        {todoList.map((value) => {
          return (
            <TodoListGroup
              key={`todolist-${value['type']}-no-${value['no']}`}
              listInfo={value}
              setModalVisible={setModalVisible}
              setModalDataList={setModalDataList}
              setCurrTask={setCurrTask}
              currTaskNo={currTaskNo}
              onTriggerSelectImg={() => {
                currTaskVal.current = value
                handleCertBtnClick(value)
              }}
              onEditTaskResult={(params) => {
                setModalVisible(false)
                const targetTask = getTaskInfo(params['task_no'])
                setCurrTask(targetTask)
                // setShowTaskResultForm(true)                currTaskVal.current = value
                currTaskVal.current = value

                handleCertModiClick(value)
              }}
              onDeleteTask={handleDeleteTask}
              onDeleteRoutine={handleDeleteRoutine}
              onDeleteTaskResult={handleTaskDeleteCenterModal}
              disableEditTask={disableEditTask}
              relation={relation}
              onError={(error) => handleError(error)}
              onShareTaskResult={handleShareTaskResult}
              onChallengeStartClick={handleChallengeStartClick}
            />
          )
        })} */}
      </BodyWrapper>
      <TaskResultFormModal
        visible={showTaskResultForm}
        setVisible={setShowTaskResultForm}
        taskInfo={currTask}
        taskNo={currTask ? currTask['no'] : null}
        onClose={() => {
          setInitUploadState(true)
        }}
        onSubmit={async (response) => {
          const targetNo = response['data']['task_no']
          const targetProof = response['data']['proof'][0]
          const point = response['data']['point']
          const permissions = response['permissions']
          const productChallengeAttendee = response['data']['product_challenge']?.attendee
          addTodoListProof(targetNo, targetProof)

          if (permissions?.length > 0) {
            const permissionTypes = []
            for (let i = 0; i < permissions.length; ++i) {
              const permissionObj = {}
              permissionObj[permissions[i]['name']] =
                permissions[i]['action'] === 'add' ? true : false
              permissionTypes.push(permissions[i]['name'])
              await UserPermissionActions.updateUserPermission(permissionObj)
            }
          }

          if (point) {
            handleOpenCompleteModal(point, permissions, productChallengeAttendee)
          }
          setInitUploadState(true)
          onEdit()
        }}
        onLoadModalId={(id) => {
          setResultModalFormId(id)
        }}
      />
      {imageConfirmModalVisible ? (
        <ImageConfirmModal
          dataList={imageConfirmModalDataList}
          onCancel={onImageConfirmModalCancel}
          onComplete={onImageConfirmModalComplete}
          lottieOptions={lottieOptions}
        />
      ) : null}
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
      <BottomModal visible={modalVisible} setVisible={setModalVisible} dataList={modalDataList} />
      <ImageModal
        visible={imageModalVisible}
        dataList={imageModalDataList}
        lottieOptions={lottieOptions}
        onComplete={imageModalComplete}
      />
      <ReviewModal
        visible={reviewModalVisible}
        setReviewModalVisible={setReviewModalVisible}
        zIndex={400}
      />
      <SocialShareModal
        visible={socialShareModalVisible}
        shareImg={shareImg}
        taskNo={shareTaskNo}
        onClose={() => {
          setInitSocialShareModal(true)
        }}
        onShare={() => {
          setInitSocialShareModal(true)
        }}
      />
      {isCertProcessing ? (
        <FullScreen>
          <div style={{ width: 'calc(100vw * (60 / 375))', height: 'calc(100vw * (60 / 375))' }}>
            <LoadingAnimation lineWidth={6} />
          </div>
        </FullScreen>
      ) : null}
    </TodoListWrapper>
  )
}
